/* eslint-disable */

import React, { useEffect, useState } from "react";

import RaindropButton, {
  ButtonStyle,
} from "../../../ui-components/raindrop-button/raindrop-button.tsx";

import RaindropInput from "../../../ui-components/raindrop-input/raindrop-input.tsx";
import RaindropInputTextArea from "../../../ui-components/raindrop-input-text-area/raindrop-input-text-area.tsx";
import Spacer from "../../../ui-components/spacer/spacer";
import { fetchGraphQL } from "../../../services/api-raindrop.js";
import OrganisationLogo from "../../../ui-components/organisation-logo/organisation-logo";
import { useNavigate } from "react-router-dom";
import RaindropCard, {
  RaindropCardStyle,
} from "../../../ui-components/raindrop-card/raindrop-card.tsx";
import RaindropMotionFadeUp from "../../../ui-components/raindrop-motion-fade-up/raindrop-motion-fade-up.tsx";

import RaindropHeading from "../../../ui-components/raindrop-heading/raindrop-heading.tsx";
import WaterfallIcon from "../../../ui-components/waterfall-icon/waterfall-icon.tsx";
import { Size } from "../../../logic/enums.ts";
import RaindropTextHeading1 from "../../../ui-components/raindrop-text-heading-1/raindrop-text-heading-1.tsx";
import RaindropTextSubtitle from "../../../ui-components/raindrop-text-subtitle/raindrop-text-subtitle.tsx";
import RaindropClickable from "../../../ui-components/raindrop-clickable/raindrop-clickable.tsx";

type Organisation = {
  id: string;
  name: string;
  presignedUrlLogo: string;
};

const RaindropCardWaterfallArticleLink = () => {
  return (
    <RaindropMotionFadeUp>
      <div className="w-full ">
        <RaindropCard style={RaindropCardStyle.Gradient}>
          <div className="flex flex-col gap-4 w-full text-left ">
            <div className="dark">
              <RaindropTextHeading1>
                What is a Raindrop Waterfall?
              </RaindropTextHeading1>
            </div>
            <h6 className="font-bold text-color-dark-text-primary opacity-70">
              You're not alone. A lot of people are confused.
            </h6>
            <div className="flex w-full items-end justify-end">
              <RaindropButton
                title="Read the article"
                to="/stratus/blog/what-is-a-waterfall"
                icon="fa-book"
                style={ButtonStyle.Secondary}
              />
            </div>
          </div>
        </RaindropCard>
      </div>
    </RaindropMotionFadeUp>
  );
};

const CreateWaterfallHeader = ({
  accountPresignedUrl,
  username,
  organisationPresignedUrl = null,
}) => {
  return (
    <div className="flex flex-col gap-4 pt-8 px-6  text-left items-center">
      <WaterfallIcon
        username={username}
        urlUser={accountPresignedUrl}
        urlOrganisation={organisationPresignedUrl}
        isLarge={true}
      />

      <h1 className="font-bold text-3xl transition-all text-center">
        Create your <span>Waterfall</span>
      </h1>
      <p className="text-color-dark-text-secondary text-center">
        The money you raise will be donated straight to your chosen
        organisation.
      </p>
    </div>
  );
};

const OrganisationListElement = ({ organisation, onSelect }) => {
  return (
    <div
      key={organisation?.id}
      onClick={() => onSelect(organisation)}
      className={
        "flex flex-row w-full gap-4 dark:text-color-dark-text-primary items-center py-1 px-2 cursor-pointer dark:hover:bg-color-dark-background-secondary hover:bg-color-background-primary hover:scale-95 transition-all rounded-lg"
      }
    >
      <OrganisationLogo src={organisation?.presignedUrlLogo} />
      <h2>{organisation?.name}</h2>
    </div>
  );
};

const SuggestionCard = ({ organisations, onSelect }) => {
  return (
    <RaindropCard>
      <div className="flex flex-col h-full w-full overflow-y-auto gap-2">
        <RaindropHeading title="Suggestions" isSecondary={true} />

        {organisations.map((organisation, index) => (
          <OrganisationListElement
            key={index}
            organisation={organisation}
            onSelect={onSelect}
          />
        ))}
      </div>
    </RaindropCard>
  );
};
const StageSelectOrganisation = ({
  values,
  onNextStage = () => {},
  setSelectedOrganisation = (o) => {},
}) => {
  const [searchText, setSearchText] = useState("");

  const [organisations, setOrganisations] = useState<Organisation[]>([]);

  const showSuggestions = searchText === "";

  const onSelect = (organisation: Organisation) => {
    setSelectedOrganisation(organisation);
    onNextStage();
  };

  useEffect(() => {
    if (searchText.length === 0) {
      setOrganisations(
        values
          .filter((value) => value.organisation)
          .map((value) => value.organisation)
      );
      return;
    }

    if (searchText.length < 3) {
      setOrganisations([]);
      return;
    }

    fetchGraphQL(`
      query {
        organisationObjects(searchText: "${searchText}", limit: 10) {
          id
          name
          presignedUrlLogo
        }
      }
    `)
      .then((result) => {
        setOrganisations(result.data.organisationObjects);
      })
      .catch((error) => {
        console.error("error", error);
      });
  }, [searchText]);

  return (
    <div
      className={"flex flex-col  items-center w-full overflow-scroll gap-4 "}
    >
      <RaindropInput
        value={searchText}
        isLarge={true}
        placeholder="Search for an organisation"
        onChange={(e) => setSearchText(e.target.value)}
      />

      {showSuggestions && (
        <SuggestionCard organisations={organisations} onSelect={onSelect} />
      )}
      {!showSuggestions && (
        <div className="flex flex-col h-full w-full overflow-y-auto gap-2">
          {organisations.map((organisation) => (
            <OrganisationListElement
              organisation={organisation}
              onSelect={onSelect}
            />
          ))}
        </div>
      )}
    </div>
  );
};

const StageTitleAndDescription = ({
  onPreviousStage = () => {},
  title,
  setTitle,
  description,
  setDescription,
  selectedOrganisation,
  currentAccountId,
}) => {
  const navigate = useNavigate();

  const [isDisabled, setIsDisabled] = useState(true);

  useEffect(() => {
    setIsDisabled(title.length === 0 || description.length === 0);
  }, [title, description]);

  const onSubmit = () => {
    fetchGraphQL(`
      mutation {
        waterfallCreate(
          accountId: "${currentAccountId}"
          title: "${title}", 
          summary: "${description}", 
          organisationId: "${selectedOrganisation.id}"
        ) {
          id
        }
      }
      `)
      .then((result) => {
        console.log("result", result);
        navigate(`/raindrop/waterfall/${result.data.waterfallCreate.id}`);
      })
      .catch((error) => {
        console.error("error", error);
      });
  };

  return (
    <div className={"flex flex-col h-full items-center w-full gap-4"}>
      <div className="flex flex-row gap-2 items-center w-full">
        <OrganisationLogo src={selectedOrganisation?.presignedUrlLogo} />
        <h2>{selectedOrganisation?.name}</h2>
      </div>
      <RaindropInput
        placeholder="Painting for Peace"
        label="What shall we call it?"
        value={title}
        onChange={(e) => setTitle(e.target.value)}
        example="Painting for Peace"
        maxLength={50}
      />
      <RaindropInputTextArea
        label="Tell us what you'll be doing"
        example="I'm going to be baking a cake every day until the end of the month!"
        isPopulatingExampleIfLocal={true}
        value={description}
        maxLength={255}
        onChange={(e) => setDescription(e.target.value)}
      />
      <Spacer />
      <div className="flex flex-row w-full gap-2">
        <RaindropButton
          isFluid={true}
          size={Size.Large}
          title="Back"
          onClick={onPreviousStage}
        />
        <RaindropButton
          isFluid={true}
          size={Size.Large}
          style={ButtonStyle.Primary}
          title="Create"
          isDisabled={isDisabled}
          onClick={onSubmit}
        />
      </div>
    </div>
  );
};

const RaindropWaterfallCreate = ({ userCurrent, values }) => {
  enum Stage {
    SelectOrganisation,
    TitleAndDescription,
  }

  const navigate = useNavigate();

  const [stage, setStage] = useState(Stage.SelectOrganisation);

  const [selectedOrganisation, setSelectedOrganisation] = useState(null);
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");

  const isAnonymous = userCurrent === null;

  if (isAnonymous) {
    return (
      <div className="flex flex-col h-full w-full items-center justify-center">
        {/* <RaindropMotionFadeUp>
          <div className="flex flex-col gap-4 items-center w-full max-w-xs">
            <p className="font-semibold text-center text-color-dark-text-secondary">
              Sign up or login to create a Raindrop Waterfall
            </p>
            <RaindropButton title="Take the tour" to={"/raindrop/tour"} />
          </div>
        </RaindropMotionFadeUp> */}
        <RaindropMotionFadeUp>
          <div className="flex flex-col gap-2 ">
            <RaindropClickable
              onClick={() => {
                navigate("/raindrop/entry");
              }}
            >
              <RaindropCard>
                <RaindropTextHeading1>
                  Login to create a waterfall
                </RaindropTextHeading1>
                <RaindropTextSubtitle>
                  To begin raising money for causes you love, you must{" "}
                  <span className="text-color-raindrop-primary font-black">
                    login.
                  </span>
                </RaindropTextSubtitle>
              </RaindropCard>
            </RaindropClickable>
            <RaindropCardWaterfallArticleLink />
          </div>
        </RaindropMotionFadeUp>
      </div>
    );
  }

  return (
    <div className={"flex flex-col h-full  gap-6 overflow-y-scroll px-4 "}>
      <CreateWaterfallHeader
        accountPresignedUrl={userCurrent.account.presignedUrl}
        organisationPresignedUrl={selectedOrganisation?.presignedUrlLogo}
      />

      {stage === Stage.SelectOrganisation && (
        <StageSelectOrganisation
          onNextStage={() => setStage(Stage.TitleAndDescription)}
          setSelectedOrganisation={setSelectedOrganisation}
          values={values}
        />
      )}

      {stage === Stage.TitleAndDescription && (
        <StageTitleAndDescription
          title={title}
          setTitle={setTitle}
          description={description}
          setDescription={setDescription}
          onNextStage={() => {}}
          onPreviousStage={() => setStage(Stage.SelectOrganisation)}
          selectedOrganisation={selectedOrganisation}
          currentAccountId={userCurrent.account.id}
        />
      )}

      <RaindropMotionFadeUp>
        <RaindropCardWaterfallArticleLink />
      </RaindropMotionFadeUp>
    </div>
  );
};

export default RaindropWaterfallCreate;
